import React, { useState } from 'react'
import { Collapse, FormControlLabel, IconButton, makeStyles, Switch, TableCell, TableRow, withStyles } from '@material-ui/core';
import { SelectorForm } from '../../IrrigationForm/components/SelectorForm';
import { HourSelector } from '../../IrrigationForm/components/HourSelector';
import { TimeOnOff } from '../../IrrigationForm/components/TimeOnOff';
import { RemoveCircle } from '@material-ui/icons';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#3B3C43",
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
	root: {
	  //flexGrow: 1,
	  marginBottom: theme.spacing(2)
	},
  }))


const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
}))(TableRow);

export const AutomaticCurtainRows = ({ Id, numberOfRule }) => {
	const [curtainName, setCurtainName] = useState(["Cortina Dcha.","Cortina Izq.","Cenital"])
	const [openHour, setOpenHour] = useState(["08:00","08:00","08:00"])
	const [closeHour, setCloseHour] = useState(["20:00","20:00","20:00"])
	const [minuts, setMinuts] = useState(["1",""])
	const optionsMinuts = [0,1,2,3,4,5,6,7,8,9,10]
    const optionsSeconds = [0,30]
    const minutsOnOff = [1,2,3,4,5,6,7,8,9,10,15,20,25,30,35,40,45,50,55,60]
	const openA = true

	const removeRule = () => {
		console.log("Remover Regla")
	}

	const handleOpenHour = (event) => {
		const newSHour = [...openHour];
		newSHour[Id] = event.target.value;
		setOpenHour([...newSHour])
	}

	const handleCloseHour = (event) => {
		const newSHour = [...closeHour];
		newSHour[Id] = event.target.value;
		setCloseHour([...newSHour])
	}

  return (
	<>
		<StyledTableRow key={`StyledTable_${Id}`}>
			<StyledTableCell component="th" scope="row" key={`Row1_${Id}`}>
			{numberOfRule}
			</StyledTableCell>
			<StyledTableCell key={`Row2_${Id}`}>
			{/* <SelectorForm
			key={`Select_${Id}`}
			valueSelected={curtainName[Id]}
			handleChangeSelect={handleChangePumps} 
			arrayOfOptions={waterPumps}
			labelName={"Bombas"} 
			id={`1_${Id}`}
			/> */}

			{curtainName[Id]}
			
			</StyledTableCell>

			<StyledTableCell key={`Row5_${Id}`} >
			<HourSelector 
			Id={Id} 
			value={openHour[Id]} 
			handleChangeHour={handleOpenHour} 
			name={"Hora de apertura"}
			/>
			</StyledTableCell>

			<StyledTableCell key={`Row5_${Id}`} >
			<HourSelector 
			Id={Id} 
			value={closeHour[Id]} 
			handleChangeHour={handleCloseHour} 
			name={"Hora de cierre"}
			/>
			</StyledTableCell>


			<StyledTableCell key={`Row10_${Id}`} >
			<IconButton key={`removeRule_${Id}`} color="secondary" aria-label="remove_rule" id={`remove_${Id}`} component="span" onClick={removeRule}>
				<RemoveCircle />
			</IconButton>  
			</StyledTableCell>
		</StyledTableRow>
          
    </>
  )
}
